module.exports = __webpack_public_path__ + "img/een-logo-white.1cf88e14.png";